module.exports = __webpack_public_path__ + "8c449a19ed7e9fe88518d6346ca3aa89.svg";